import converter from "../../../libs/number-to-words";
import common from "../../common";
import QuestionModel from "../../maths/QuestionModel";
import QuestionView from "./QuestionView";

export default class QuestionViewStatement extends QuestionView {
    constructor(question) {
        super(question);

        this._footer.statement = new PIXI.Container();
        this._footer.addChild(this._footer.statement);

        this._confirmButton.x = this._footer.x + 400;

        this._minimumFontSize = this.calculateFontSize(this._question.values);
        this._minimumStatementSpacing = this.calculateStatementSpacing(this._question.values);

        this.createStatement(this._minimumStatementSpacing);
    }

    createStatement(spacing = 16) {
        let width = 0;

        let operands = [];
        if (this._question.operands !== undefined && this._question.operands.length > 0) {
            operands = this._question.operands.slice();
            operands.push("=");
        } else {
            for (let i = 1; i < this._question.values.length; ++i) {
                let operand = "=";
                if (i < this._question.values.length - 1) {
                    switch (this._question.type) {
                        case QuestionModel.TYPE_ADDITION : {
                            operand = "+";
                            break;
                        }
                        case QuestionModel.TYPE_SUBTRACTION : {
                            operand = "-";
                            break;
                        }
                        case QuestionModel.TYPE_MULTIPLICATION : {
                            operand = "×";
                            break;
                        }
                        case QuestionModel.TYPE_DIVISION : {
                            operand = "÷";
                            break;
                        }
                    }
                }
                operands.push(operand);
            }
        }

        for (let i = 0, j = 0; i < this._question.values.length; ++i) {
            const value = this._question.values[i];

            if (i !== this._question.part) {
                const label = this.createLabel(value.toString());
                label.position.set(width, 0);
                this._footer.statement.addChild(label);

                width += label.textWidth;
                (i < this._question.values.length - 1) && (width += spacing);

            } else {
                width += this._inputField.width * 0.5;

                this._inputField.position.set(width, 0);
                this._footer.statement.addChild(this._inputField);

                width += this._inputField.width * 0.5;
                i < this._question.values.length - 1 && (width += spacing);
            }

            // add operand
            const label = this.createLabel(operands[j++]);
            label.position.set(width, 0);
            this._footer.statement.addChild(label);

            width += label.textWidth;
            i < this._question.values.length - 1 && (width += spacing);
        }

        // center statement
        this._footer.statement.pivot.x = width * 0.5;
    }

    createLabel(text = "") {
        const label = new PIXI.extras.BitmapText(text, {
            font: {name: "BBC Reith Sans Math Large", size: this._minimumFontSize}, tint: 0x0
        });
        label.anchor.set(0, 0.5);
        this._footer.statement.addChild(label);
        return label;
    }

    calculateFontSize(values) {
        let size = 48;

        if (values.length > 4) {
            return 26;
        }

        for (let i = 0; i < values.length; ++i) {
            const value = values[i];
            const str = value.toString();
            if (str.length >= 8) {
                return 20;
            } else if (str.length >= 6) {
                return 32;
            } else if (str.length >= 5) {
                return 36;
            }
        }

        /*
        let longest = 0;

        for (let i = 0; i < values.length; ++i)
        {
            const value = values[i];
            const str = value.toString();

            if (str.length >= 8)
            {
                if (str.length > longest)
                {
                    longest = 8;
                    size = 20;
                }
            }
            else if (str.length >= 6)
            {
                if (str.length > longest)
                {
                    longest = 6;
                    size = 32;
                }
            }
            else if (str.length >= 5)
            {
                if (str.length > longest)
                {
                    longest = 5;
                    size = 36;
                }
            }
        }
        */

        return size;
    }

    calculateStatementSpacing(values) {
        const spacing = 16;

        if (values.length > 4) {
            return 6;
        }

        for (let i = 0; i < values.length; ++i) {
            const value = values[i];
            const str = value.toString();
            if (str.length >= 6) {
                return 9;
            } else if (str.length >= 5) {
                return 12;
            }
        }
        return spacing;
    }
}